// @ts-check
const { __, sprintf } = wp.i18n;

import { getPlotNumberIdFromShapeLink } from './svgMapHelpers.js';

// TODO: mapping is are never a good thing
/**
 *
 * @param {string} name
 * @param {import('../types').PlotNumber} plotNumber
 * @returns {string | number?}
 */
const mapFieldNameToPlotMapPropertyForModal = (name, plotNumber) => {
	switch (name) {
	case 'name':
		return plotNumber.name;
	case 'b_bouwnummer':
		return plotNumber.number;
	case 'plot_type_of_house':
		return plotNumber.houseType.label;
	case 'w_kaveloppervlakte':
		return plotNumber.lotAreaInSquareMetersFormatted;
	case 'w_woonoppervlakte':
		return plotNumber.livingAreaInSquareMetersFormatted;
	case 'w_inhoud':
		return plotNumber.contentInCubicMetersFormatted;
	case 'w_balkonoppervlakte':
		return plotNumber.balconySurfaceInSquareMetersFormatted;
	case 'plot_balcony_location':
		return plotNumber.balconyLocation.label;
	case 'plot_loggia_surface':
		return plotNumber.loggiaSurfaceInSquareMetersFormatted;
	case 'plot_loggia_location':
		return plotNumber.loggiaLocation.label;
	case 'plot_terrace_surface':
		return plotNumber.terraceSurfaceInSquareMetersFormatted;
	case 'plot_terrace_location':
		return plotNumber.terraceLocation.label;
	case 'plot_other_indoor_space':
		return plotNumber.otherIndoorSpaceInSquareMetersFormatted;
	case 'plot_building_related_outdoor_space':
		return plotNumber.buildingRelatedOutdoorSpaceInSquareMetersFormatted;
	case 'plot_external_storage_space':
		return plotNumber.getExternalStorageInSquareMetersFormatted;
	case 'plot_number_of_rooms':
		return plotNumber.numberOfRooms;
	case 'w_number_of_bedrooms':
		return plotNumber.numberOfBedrooms;
	case 'w_number_of_bathrooms':
		return plotNumber.numberOfBathrooms;
	case 'plot_garden_location':
		return plotNumber.gardenLocation.label;
	case 'plot_garden_surface':
		return plotNumber.gardenSurfaceInSquareMetersFormatted;
	case 'plot_floor':
		return plotNumber.floor;
	case 'w_prijs':
		return plotNumber.priceFormattedWithComposition;
	case 'w_prijsbereik':
		return plotNumber.priceRangeFormatted?.from && plotNumber.priceRangeFormatted?.to ? sprintf(__('%s to %s %s', 'real-estate-project'), plotNumber.priceRangeFormatted.from, plotNumber.priceRangeFormatted.to, plotNumber.priceRangeCompositionSuffix) : '';
	case 'w_status':
		return plotNumber.status.label;
	case 'house-model-name':
		return plotNumber.houseModel?.name ? plotNumber.houseModel.name : '';
	}

	return null;
};

/**
 * @param {import('../types').PlotNumber?} plotNumber
 * @param {import('../types').PlotNumberPropertiesToShow[]} infoToShow
 * @returns {import('../types').PlotNumberWithProperties?}
 */
const getPlotNumberForModal = (plotNumber, infoToShow) => {
	if (!plotNumber) {
		return plotNumber;
	}

	return {
		...plotNumber,
		properties: infoToShow.map(info => ({
			...info,
			value: mapFieldNameToPlotMapPropertyForModal(info.name, plotNumber)
		})).filter(property => property.value)
	};
};

/**
 * @param {import('../types').Group} group
 * @param {import('../types').PlotNumber[]} plotNumbers
 * @returns {import('../types').PlotNumber[]}
 */
const getPlotNumbersByGroup = (group, plotNumbers) => {
	const uniqueShapes = group.views.map(view => view.shapes).flat().filter((shape, index, allShapes) => (
		allShapes.findIndex(shapeAll => shapeAll.link === shape.link) === index
	));

	return uniqueShapes.map(shape => {
		const plotNumberId = getPlotNumberIdFromShapeLink(shape.link);
		if (!plotNumberId) {
			return null;
		}

		return plotNumbers.find(plotNumber => plotNumber.id === plotNumberId) || null;
	}).filter(plotNumber => plotNumber !== null);
};

/**
 * @param {import('../types').PlotNumber[]} plotNumbers
 * @param {import('../types').StatusValue[]} propertyValues
 * @returns {import('../types').StatusValue?}
 */
const returnContainsStatusFromPlotNumbers = (plotNumbers, propertyValues) => {
	for (let value of propertyValues) {
		for (let plotNumber of plotNumbers) {
			if (plotNumber.status.value === value) {
				return value;
			}
		}
	}

	return null;
};

/**
 * @param {import('../types').PlotNumber[]} plotNumbers
 * @returns {import('../types').PlotNumber[]}
 */
const getMatchedPlotNumbers = (plotNumbers) => plotNumbers.filter(plotNumber => plotNumber.isMatch);

/**
 * @param {import('../types').PlotNumber[]} plotNumbers
 * @returns {number}
 */
const getFilterMatchCount = (plotNumbers) => getMatchedPlotNumbers(plotNumbers).length;

export {
	getPlotNumberForModal,
	getPlotNumbersByGroup,
	returnContainsStatusFromPlotNumbers,
	getMatchedPlotNumbers,
	getFilterMatchCount
};